seedWebApp.controller('404PageController', ['$scope',
    function ($scope) {
        console.log('404PageController');

    }

]);
